import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_FhirResolver = {
    _v1: {
        searchFhir: { method: HttpMethod.POST, path: '/v1/fhir-resolver/perform-search', timeout: Minute },
    }
};
//# sourceMappingURL=apis.js.map